import React from "react";

type InvestmentsPageStateProps = {
  message: string;
};

export function InvestmentsPageState({ message }: InvestmentsPageStateProps): JSX.Element {
  return <div className="investments-state">{message}</div>;
}

type InvestmentsLoadingScreenProps = {
  message: string;
};

export function InvestmentsLoadingScreen({ message }: InvestmentsLoadingScreenProps): JSX.Element {
  return (
    <main className="investments-page investments-loading-page" aria-busy="true">
      <div className="investments-shell investments-loading-shell">
        <header className="investments-loading-header">
          <div>
            <div className="section-eyebrow">Investments</div>
            <h1>Research workspace</h1>
            <p>Preparing the latest cached analysis.</p>
          </div>
          <div className="investments-loading-badge">Cached research</div>
        </header>

        <div className="investments-loading-nav" aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>

        <section className="investments-loading-status" role="status" aria-live="polite">
          <div className="investments-loading-indicator" aria-hidden="true">
            <span />
            <span />
            <span />
          </div>
          <div>
            <strong>{message}</strong>
            <p>Reading local snapshots and assembling the workspace.</p>
          </div>
        </section>

        <div className="investments-loading-grid" aria-hidden="true">
          <div className="investments-loading-metrics">
            <span />
            <span />
            <span />
          </div>
          <div className="investments-loading-panel">
            <span className="investments-loading-line investments-loading-line-short" />
            <span className="investments-loading-line" />
            <span className="investments-loading-line" />
            <span className="investments-loading-line investments-loading-line-medium" />
          </div>
        </div>
      </div>
    </main>
  );
}
